import { PACKAGES } from "@/lib/compPlan";
import { fmtMoney } from "@/lib/simulator";
import { Check } from "@phosphor-icons/react";
import { SIM } from "@/constants/testIds";

/**
 * Large card-grid picker for the 5 U.CENTER packages.
 * Selected card gets a ring + check badge; each card shows price + rank unlock.
 */
export default function PackagePicker({ value, onChange, compact = false }) {
  return (
    <div
      className={
        compact
          ? "grid grid-cols-2 sm:grid-cols-5 gap-2"
          : "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3"
      }
    >
      {PACKAGES.map((p) => {
        const selected = value === p.id;
        return (
          <button
            key={p.id}
            type="button"
            data-testid={SIM.packageCard(p.id)}
            onClick={() => onChange(p.id)}
            className={`group relative text-left rounded-xl transition-all duration-200 focus:outline-none ${
              compact ? "px-2.5 py-2" : "p-4"
            } ${
              selected
                ? "bg-white/[0.06] ring-2 ring-pink-400/70 shadow-lg shadow-pink-500/20"
                : "bg-white/[0.03] ring-1 ring-white/[0.06] hover:ring-white/25 hover:bg-white/[0.05]"
            }`}
            style={selected ? { borderColor: p.color } : undefined}
          >
            {selected && (
              <span className="absolute top-2 right-2 h-5 w-5 rounded-full bg-gradient-to-br from-pink-500 to-orange-500 flex items-center justify-center">
                <Check weight="bold" className="h-3 w-3 text-white" />
              </span>
            )}
            <span
              className="block h-1.5 w-8 rounded-full mb-2"
              style={{ background: p.color, boxShadow: `0 0 12px ${p.color}55` }}
            />
            <div className={`font-display font-semibold text-white ${compact ? "text-xs" : "text-base"}`}>
              {p.name}
            </div>
            <div className={`font-mono text-slate-300 mt-0.5 ${compact ? "text-[10px]" : "text-sm"}`}>
              {fmtMoney(p.price)}
            </div>
            {!compact && (
              <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-2">
                Rank R{p.packageRankIdx + 1}
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
